<template >
  <div class="cola-right">
    <div class="cola-right-subject">
      <!-- 写实模式，水晶模式等 -->
      <div class="cola-list">
        <div
          class="cola-list-new"
          v-for="(item, i) in list"
          :key="i"
          v-show="item.status == 0 && btnshow"
        >
          <span
            :style="{ color: l == i ? '#fff' : 'rgb(156, 200, 255)' }"
            @click="listcloa(i)"
          >{{ item.name }}</span>
          <div>
            <img :src="item.imaeg" alt />
          </div>
        </div>
      </div>

      <!-- 3个迅游 -->
      <div class="roam" v-show="btnshow && show">
        <div :class="l == 3 ? 'roam-now1' : 'roam-now'">
          <span :style="{ color: setat == 1 ? '#9cc8ff' : '#fff' }" @click="pipeline(1, 3)">主运巷道</span>
          <span
            :style="{ color: setat == 2 ? '#9cc8ff' : '#fff' }"
            @click="pipeline(2, 4)"
            v-show="show"
          >煤巷游览</span>
          <span :style="{ color: setat == 3 ? '#9cc8ff' : '#fff' }" @click="pipeline(3, 5)">回风巷道</span>
        </div>
      </div>

      <div class="orientation" v-show="btnshow && show">
        <div :class="l == 5 ? 'roam-now1' : 'roam-now'">
          <span :style="{ color: setat == 1 ? '#9cc8ff' : '#fff' }" @click="looking(1, 1)">主运工作面</span>
          <span :style="{ color: setat == 2 ? '#9cc8ff' : '#fff' }" @click="looking(2, 2)">中央变电所</span>
          <span :style="{ color: setat == 3 ? '#9cc8ff' : '#fff' }" @click="looking(3, 3)">井底车场</span>
        </div>
      </div>

      <!-- 风险隐患区域 -->
      <div class="area" v-show="btnshow && show">
        <div
          class="area-now"
          :style="{ backgroundImage: `url(${item.backing})` }"
          v-for="(item, i) in dqlist"
          :key="i"
          @click="risktt(i)"
        >
          <div>
            <img :src="item.imag" alt />
          </div>
          <span :style="{ color: item.color }">{{ item.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "moalLeft",
  data() {
    return {
      l: 0,
      list: [
        {
          name: "水晶模式",
          imaeg: require("../../assets/sjms.png"),
          status: 0
        },
        {
          name: "实景渲染",
          imaeg: require("../../assets/sjxr.png"),
          status: 0
        },
        {
          name: "整体视角",
          imaeg: require("../../assets/ztsj.png"),
          status: 0
        },
        {
          name: "自动漫游",
          imaeg: require("../../assets/zdmy.png"),
          status: 0
        },
        {
          name: "手动漫游",
          imaeg: require("../../assets/sdmy.png"),
          status: 0
        },
        {
          name: "快速定位",
          imaeg: require("../../assets/ksdw.png"),
          status: 0
        },
        {
          name: "工作模拟",
          imaeg: require("../../assets/zymn.png"),
          status: 1
        },
        {
          name: "停止模拟",
          imaeg: require("../../assets/tzmn.png"),
          status: 1
        },
        {
          name: "采 煤 机",
          imaeg: require("../../assets/cmj.png"),
          status: 1
        },
        {
          name: "掘 进 机",
          imaeg: require("../../assets/jjj.png"),
          status: 1
        }
      ],

      dqlist: [
        {
          name: "隐患区域",
          imag: require("../../assets/yh.png"),
          color: "#ffc521",
          backing: require("../../assets/yhqy.png")
        },
        {
          name: "风险区域",
          imag: require("../../assets/wx.png"),
          color: "#ff0000",
          backing: require("../../assets/fxqy.png")
        }
      ],
      setat: 0,
      //
      item: 0,
      timer: null,
      show: true,
      nowpage:0,
    };
  },
  props: {
    btnshow: Boolean
  },
  mounted() {
    // 传到cloab.vue 其实里面啥都不用传
    this.emit.$on("item", e => {
      console.log(e, "dsada");
      // this.l = 0;
      this.nowpage = e;
      if (e == 0) {
        this.show = true;
        this.list[0].status = 0;
        this.list[1].status = 0;
        this.list[2].status = 0;
        this.list[4].status = 0;
        this.list[3].status = 0;
        this.list[5].status = 0;
        this.list[6].status = 1;
        this.list[7].status = 1;
        this.list[8].status = 1;
        this.list[9].status = 1;
        // this.btnshow = true;
      } else if(e == 1){
        this.show = false;
        this.list[0].status = 1;
        this.list[1].status = 1;
        this.list[2].status = 1;
        this.list[4].status = 1;
        this.list[3].status = 1;
        this.list[5].status = 1;
        this.list[6].status = 0;
        this.list[7].status = 0;
        this.list[8].status = 0;
        this.list[9].status = 1;
        // this.btnshow = false;
      } else if(e == 2){
        this.show = false;
        this.list[0].status = 1;
        this.list[1].status = 0;
        this.list[2].status = 1;
        this.list[4].status = 1;
        this.list[3].status = 1;
        this.list[5].status = 1;
        this.list[6].status = 0;
        this.list[7].status = 0;
        this.list[8].status = 1;
        this.list[9].status = 0;
      }
      this.setat = 100;
    });
  },
  methods: {
    listcloa(a) {
      if (this.l == 3) {
        this.l = 6;
      }
      if (this.l == 5) {
        this.l = 6;
      }
      // 有个 一秒只能点一次
      if (this.item == 0) {
        clearTimeout(this.timer);
        this.timer = null;
        this.l = a;
        // 方法对象
        let obg = {
          0: () => {
            document.getElementById("iframe").contentWindow.MMAPI.rigthnav(0);
          },
          1: () => {
            document.getElementById("iframe").contentWindow.MMAPI.rigthnav(1);
          },
          2: () => {
            document.getElementById("iframe").contentWindow.MMAPI.rigthnav(2);
          },
          3: () => {},
          4: () => {
            document.getElementById("iframe").contentWindow.MMAPI.rigthnav(6);
          },
          5: () => {},
          6: () => {  
            if(this.nowpage == 1){
              document.getElementById("iframe").contentWindow.MMAPI.beginDraw();
            }else{
              document.getElementById("iframe").contentWindow.MMAPI.jjjwork(true);         	
            }
          },
          7: () => {
            if(this.nowpage == 1){
               document.getElementById("iframe").contentWindow.MMAPI.endDraw();   
            }else{
                document.getElementById("iframe").contentWindow.MMAPI.jjjwork(false);   
            }
          },
          8: () => {
            document.getElementById("iframe").contentWindow.MMAPI.cmj();        	
          },
          9: () => {
            document.getElementById("iframe").contentWindow.MMAPI.jjj();         	
          }
        };
        // 调用三维的方法
        obg[a]();
        this.item = 1;
        this.timer = setTimeout(() => {
          this.item = 0;
        }, 1000);
      }
    },

    // 迅游的 点击函数
    pipeline(i, a) {
      this.setat = i;
      // 三维巡游函数 
      document.getElementById("iframe").contentWindow.MMAPI.rigthnav(a);
    },
    // 迅游的 点击函数
    looking(i, a) {
      this.setat = i;
      // 三维巡游函数 
      document.getElementById("iframe").contentWindow.MMAPI.quick(a);
    },

    // 隐患 和风险区域函数
    risktt(i) {
      // 传到
      this.emit.$emit("block");
      // // 三维 隐患区域函数
      document.getElementById("iframe").contentWindow.MMAPI.rish();
      if(i == 0){
        this.$parent.bianhuang();
      }else if( i == 1){
        this.$parent.bianhong();
      }
    }
  }
};
</script>
<style lang="less" scoped>
.cola-right {
  width: 24%;
  height: 100%;
  background-image: url(../../assets/ybj.png);
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  right: 0;
  pointer-events: none;
  .cola-right-subject {
    width: 80%;
    height: 95%;
    position: absolute;
    right: 0;
    top: 0;
    background-image: url("../../assets/ybk.png");
    background-size: 100% 100%;
    margin-top: 4vh;
    pointer-events: auto;
    .cola-list {
      position: absolute;
      top: 30vh;
      right: 0;
      width: 7vw;
      height: 27.5vh;
      .cola-list-new {
        width: 100%;
        height: 20%;
        display: flex;
        align-items: center;
        justify-content: space-around;

        span {
          font-size: 0.8vw;
          color: rgb(156, 200, 255);
          font-weight: 400%;
          cursor: pointer;
          transition: color 1s;
        }
        span:hover {
          color: rgb(255, 255, 255) !important;
        }
        div {
          width: 20%;
          height: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
    .area {
      width: 18vw;
      height: 12vh;
      position: absolute;
      bottom: 9vh;
      right: 5vw;
      z-index: 2;
      display: flex;
      justify-content: space-around;
      align-items: center;
      background-image: url("../../assets/bj.png");
      background-size: 100% 100%;
    }
    .area-now {
      width: 40%;
      height: 60%;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      cursor: pointer;
      div {
        width: 2vw;
        height: 4vh;
        img {
          width: 100%;
          height: 100%;
        }
      }
      span {
        font-size: 0.8vw;
        color: #fff;
      }
    }
  }
}
.roam {
  position: absolute;
  right: 35%;
  top: 50.5%;
  padding: 0.2vh 0.5vw;
  overflow: hidden;
  .roam-now {
    transform: translateX(110%);
    transition: all 0.5s;
    background-image: linear-gradient(
      to left,
      rgba(1, 78, 147, 1),
      rgba(1, 78, 147, 0.1)
    );
    span {
      font-size: 0.8vw;
      margin: 0 0.3vw;
      cursor: pointer;
      color: #fff;
      transition: all 1s;
    }
    span:hover {
      color: "#9cc8ff";
    }
  }
}
.roam-now1 {
  transform: translateX(0%);
  transition: all 0.5s;
  background-image: linear-gradient(
    to left,
    rgba(1, 78, 147, 1),
    rgba(1, 78, 147, 0.1)
  );
  white-space: nowrap;
  span {
    font-size: 0.7vw;
    margin: 0 0.3vw;
    cursor: pointer;

    color: #fff;
  }
  span:hover {
    color: #9cc8ff;
  }
}
.orientation {
  position: absolute;
  right: 35%;
  top: 62%;
  padding: 0.2vh 0.5vw;
  overflow: hidden;
  .roam-now {
    transform: translateX(110%);
    transition: all 0.5s;
    background-image: linear-gradient(
      to left,
      rgba(1, 78, 147, 1),
      rgba(1, 78, 147, 0.1)
    );
    white-space: nowrap;
    span {
      font-size: 0.7vw;
      margin: 0 0.3vw;
      cursor: pointer;
      color: #fff;
    }
    span:hover {
      color: "#9cc8ff";
    }
  }
}
</style>